import { useEffect } from 'react';
import { useTimedLoading } from './useTimedLoading';

/**
 * Centralized hook to manage the warm‑up timer based on a loading flag.
 *
 * @param {boolean} isLoading - Current loading state of the component.
 * @returns {{ isWarmup: boolean }} - Warm‑up flag to pass to <Loading />.
 *
 * Usage:
 *   const { isWarmup } = useWarmupTimer(isLoading);
 */
export const useWarmupTimer = (isLoading) => {
  const { isWarmup, start, reset } = useTimedLoading();

  useEffect(() => {
    if (isLoading) {
      start();
    } else {
      reset();
    }
  }, [isLoading, start, reset]);

  // Return the warm‑up flag along with the control functions
  return { isWarmup, start, reset };
};